import _ from 'lodash';

const root = state => _.get(state, 'ManageApplicationState.manageApplication');

export const getAutoPopulateStudentData = state =>
  _.get(root(state), 'autoPopulateStudentData');



// WEBPACK FOOTER //
// ./src/pages/manageapplication/state/manageapplication/selectors.js